import axios from 'axios'
import { CreateEditFillingStationType } from '../Models/fillingStationType'
import { AxiosInterceptor } from '../Config/AxiosInterceptor'

AxiosInterceptor()

const fillingStationService = {
  async getAll(pageNumber: number) {
    return axios.get(`/filling-stations?pageNumber=${pageNumber}`)
  },

  async getById(id: string) {
    return axios.get(`/filling-stations/${id}`)
  },

  async create(data: CreateEditFillingStationType) {
    return axios.post('/filling-stations', data)
  },

  async update(id: string, data: CreateEditFillingStationType) {
    return axios.put(`/filling-stations/${id}`, data)
  },

  async delete(id: string) {
    return axios.delete(`/filling-stations/${id}`)
  },
}

export default fillingStationService
